<template>
  <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
  <base-notice-item :button-text="$t('Add your address')" :button-url="buttonUrl">
    <template #head>
      <strong>{{ $t('Add your business address') }}</strong>
    </template>
    <template #body>
      {{
        $t(
          'In order to offer contracts to freelancers, we will need to get the full ' +
            'address of your business, so that we can approve your job.',
        )
      }}
    </template>
    <template #status>Status: {{ $t('Information missing') }}</template>
  </base-notice-item>
</template>

<script>
/* eslint-disable import-x/extensions */
import RedirectUriMixin from '@/mixins/RedirectUriMixin'
import { laravelNamedRoute } from '@/utils/laravelNamedRoutes'
import namedRoutes from '@/utils/laravelNamedRoutes.json'

export default {
  name: 'CompanyAddressCompanyAlert',
  mixins: [RedirectUriMixin],
  computed: {
    buttonUrl() {
      return laravelNamedRoute(
        namedRoutes.frontend.user.profile.edit,
        {
          redirect_uri: this.redirectUri,
        },
        false,
      )
    },
  },
}
</script>
